import { RouteComponentProps } from '@reach/router'
import { Box, Avatar, BoxComponentProps } from 'reoil'
import Navigation from '../components/Navigation'
import useFetchResume from '../hooks/api/useFechResume'
import { responseBoxProp } from '../utils/propsHelpers'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { useThemeValue } from '../store/themeState'
import BtnBottom from '../components/BtnBottom'
import goto from '../utils/goto'

const UserResumePage: React.FC<RouteComponentProps> = () => {
  // 全局状态
  const theme = useThemeValue()

  // 获取简历数据
  const {data} = useFetchResume()
  const info = data?.data

  // // 获取城市数据
  // const {data: CitiesData} = useFetchCities()
  // const cities = CitiesData?.data
  // const interviewCities = cities?.interview // 面试意向城市
  // const jobsCities = cities?.jobs // 工作意向城市

  // const getInterviewCityNameById = (id: string):string=>{
  //   return interviewCities?.find(item=>item.id === id)?.name || ''
  // }

  const formatedInterviewCity = info?.interviewCityIDs
  // const formatedIntendedCities = info?.intendedJobs.join('、')

  
  // 点击编辑
  const handleClickEdit = ()=>{
    goto('/user/resume/edit')
  }

  if(info) {return(
    <Box className='UserResumePage' stretch pb={6}>
      <Navigation title='我的简历' hideAvatar height={59} />

      <Box className="form" p={3} bg='white'>
        <SubTitle>基本信息</SubTitle>
        <Box {...responseBoxProp} stretch css={css`
          h4 {
            margin-bottom: 8px;
          }
          p {
            margin: 0;
            font-size: 14px;
            color: ${theme.colors.text.body2};
            white-space: pre-wrap;
          }
        `}>

          <Box className='userinfo' row center left mb={4}>
            <Box>
              <h4>{info.userName}</h4>
              <p>{info.gender==='1'?'男':'女'}·{info.birthDate}</p>
            </Box>
            <Avatar size={40} src={info.headImg as string} border='divider' ml='auto' />
          </Box>

          <Box center left mb={4}>
            <h4>身份证号码</h4>
            <p>{info.idCard}</p>
          </Box>

          <Box center left mb={4}>
            <h4>最高学历</h4>
            <p>{info.education}</p>
          </Box>

          <Box center left mb={4}>
            <h4>政治面貌</h4>
            <p>{info.politic}</p>
          </Box>

          <Box center left mb={4}>
            <h4>民族</h4>
            <p>{info.userNation}</p>
          </Box>

          <Box center left mb={4}>
            <h4>籍贯</h4>
            <p>{info.nativePlace}</p>
          </Box>

          <Box center left mb={4}>
            <h4>户口所在地</h4>
            <p>{info.registeredResidence}</p>
          </Box>

          <Box center left mb={4}>
            <h4>身高体重</h4>
            <p>{info.height}cm·{info.weight}kg</p>
          </Box>
          
          <Box center left mb={4}>
            <h4>婚姻状况</h4>
            <p>{info.marryStatus==='1'?'已婚':'未婚'}</p>
          </Box>

          <Box center left mb={4}>
            <h4>外语水平</h4>
            <p>{info.foreignLanguageLevel}</p>
          </Box>

          <Box center left mb={4}>
            <h4>计算机水平</h4>
            <p>{info.computerLevel}</p>
          </Box>

          <Box center left mb={4}>
            <h4>邮箱地址</h4>
            <p>{info.email}</p>
          </Box>

          <Box center left mb={4}>
            <h4>特长与爱好</h4>
            <p>{info.specialty}</p>
          </Box>

          <Box center left mb={4}>
            <h4>是否服从调剂</h4>
            <p>{info.canAdjustment==='1'?'服从调剂':'不服从调剂'}</p>
          </Box>

          {/* <Box center left mb={4}>
            <h4>意向工作岗位</h4>
            <p>{formatedIntendedCities}</p>
          </Box> */}

          <Box center left mb={4}>
            <h4>意向笔面试城市</h4>
            <p>{formatedInterviewCity}</p>
          </Box>

          <Box center left mb={4}>
            <h4>获奖情况</h4>
            <p>{info?.award || '无'}</p>
          </Box>

          <Box center left mb={4}>
            <h4>自我评价</h4>
            <p>{info?.selfEval || '无'}</p>
          </Box>

          <SubTitle>教育经历</SubTitle>

          {info.educationDetailList.map((item, i)=>(
            <Box center left mb={4} key={i}>
              <h4>{i+1}. {item.school}</h4>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>入学至毕业：</p>
                <p>{item.fromdate || '----'} 至 {item.todate || '----'}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>院系:</p>
                <p>{item.department || ''}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>专业:</p>
                <p>{item.major || ''}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>排名:</p>
                <p>{item.majorRanking || ''}</p>
              </Box>
            </Box>
          ))}

          <SubTitle>学生工作</SubTitle>

          {info.studentUnionList.map((item, i)=>(
            <Box center left mb={4} key={i}>
              <h4>{i+1}. {item.organizationName}</h4>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>开始至结束：</p>
                <p>{item.fromdate || '----'} 至 {item.todate || '----'}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>职位名称:</p>
                <p>{item.positionName || ''}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>工作内容与成果:</p>
                <p>{item.workContent || ''}</p>
              </Box>
            </Box>
          ))}

          <SubTitle>实践（工作）经历</SubTitle>

          {info.practiceExperienceList.map((item, i)=>(
            <Box center left mb={4} key={i}>
              <h4>{i+1}. {item.organizationName}</h4>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>开始至结束：</p>
                <p>{item.fromdate || '----'} 至 {item.todate || '----'}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>工作岗位:</p>
                <p>{item.positionName || ''}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>实践（工作）经历描述:</p>
                <p>{item.experience || ''}</p>
              </Box>
              {/* <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>获奖情况:</p>
                <p>{item.awards || ''}</p>
              </Box> */}
            </Box>
          ))}

          <SubTitle>作品代表</SubTitle>

          {info.awardInfoList.map((item, i)=>(
            <Box center left mb={4} key={i}>
              <h4>{i+1}. {item.name}</h4>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>完成时间:</p>
                <p>{item.finisheddate}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>作品类型:</p>
                <p>{item.type || ''}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>刊发处:</p>
                <p>{item.publishingOffice || ''}</p>
              </Box>
              <Box row>
                <p style={{minWidth: 120, whiteSpace: 'nowrap'}}>作品链接地址:</p>
                <p>{item.link || ''}</p>
              </Box>
            </Box>
          ))}

          <Box center left mb={4}>
            <h4>简历文件</h4>
            <p>{info.resumeFile}</p>
          </Box>

          <SubTitle>问答题</SubTitle>

          <Box center left mb={4}>
            <h4>1. 您对未来有什么规划和想法？</h4>
            <p>{info.answer2}</p>
          </Box>

          <Box center left mb={4}>
            <h4>2. 校园宣讲会上您最想提问的问题是什么？</h4>
            <p>{info.answer3}</p>
          </Box>

        </Box>
      </Box>

      <BtnBottom onClick={handleClickEdit}>修改简历</BtnBottom>
    </Box>
  )}else {
    return <div></div>
  }
}

const SubTitle: React.FC<BoxComponentProps> = ({...props})=>{
  return <Box className='subtitle' fullWidth center color='text.caption' fontWeight='normal' fontSize={1} mb={3} pb={2} borderBottom='' {...props}>{props.children}</Box>
}

export default UserResumePage
